const types = {
  SET_SIMULATION: "SET_SIMULATION",
  SET_MODALIDAD: "SET_MODALIDAD",
  SET_FINANCIAL_ENTITIE: "SET_FINANCIAL_ENTITIE",
  SET_SELECTED_STATE: "SET_SELECTED_STATE",
  SET_SELECTED_CITY: "SET_SELECTED_CITY",
  SET_ACCOUNT_TYPE: "SET_ACCOUNT_TYPE",
  SET_DISBURSEMENT_MODALITY_DATA: "SET_DISBURSEMENT_MODALITY_DATA",
  SET_MEANS_OF_DISBURSEMENT: "SET_MEANS_OF_DISBURSEMENT",
  SET_CLIENT_TYPE: "SET_CLIENT_TYPE",
  SET_CREDIT: "SET_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION"
}

export default types
